document.addEventListener('DOMContentLoaded', function() {
  /* ---- COLORIZE FUNCTION ---- */
function colorizeTimer(el) {
  if (!el || !el.dataset.colored) return;

  const txt = el.textContent.trim();
  const parts = txt.split(" ");

  const html = parts
    .map(part => {
      const num = part.match(/\d+/)?.[0] || "";
      const label = part.replace(num, "");
      return `<span class="timer-num">${num}</span>${label}`;
    })
    .join(" ");

  el.innerHTML = html;
}
  /* ---- FIND TIMER ELEMENT ---- */
  var root = document.querySelector('.bf-hero-banner[data-section-id="{{ section.id }}"]');
  if (!root) return;

  var timerEl = root.querySelector('.bf-hero-banner__timer-value');
  if (!timerEl) return;

  var endStr = timerEl.getAttribute('data-bf-start');
  if (!endStr) return;

  var endDate = new Date(endStr);
  if (isNaN(endDate.getTime())) return;
  /* ---- UTILS ---- */
  function pad(v) {
    return String(v).padStart(2, '0');
  }

  /* ---- TIMER LOOP ---- */
  function updateTimer() {
    var now = new Date();
    var diffMs = endDate - now;

    if (diffMs <= 0) {
      timerEl.textContent = '00H 00MIN 00S';
      colorizeTimer(timerEl);
      return;
    }
    var totalSeconds = Math.floor(diffMs / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    timerEl.textContent =
      pad(hours) + 'H ' +
      pad(minutes) + 'MIN ' +
      pad(seconds) + 'S';

    /* ★ APPLY COLOR EVERY TICK ★ */
    colorizeTimer(timerEl);
  }

  /* Start */
  updateTimer();
  setInterval(updateTimer, 1000);
});
